import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import axios from 'axios';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import AccountList from '../component/Account/AccountList';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import Main_Summer from '../component/Summer/Main_Summer';
import Save_Date from '../component/Save_Date';
import Info_Spring from '../component/Spring/Info_Spring';
import Interview_Spring from '../component/Spring/Interview_Spring';
import CallInfo from '../component/CallInfo';

const LeeHaRin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "문병관 ♥ 이하린 결혼합니다.";
    const openDesc = "2025.04.27.일요일 13시 30분 \n파라다이스컨벤션웨딩 3층 스텔라홀";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/91/thumb.png";

    const lng =  128.5332584;
    const lat =  35.8368657;

    const placeTelNum = "053-552-0500";

    const forCar = "네비게이션 '대구 파라다이스컨벤션웨딩' 또는 \n도로명 주소 '대구 달서구 구마로 52' 입력";
    const forSubway = "* 동대구역에서 지하철 1호선 탑승 \n- 서부정류장 1번 출구 건너 버스 환승 또는 \n택시(5분 소요), 환승버스 564 (남대구IC 정류장 하차), \n641 (본리네거리2하차)\n\n* 지하철 2호선 탑승 \n- 두류역 하차 후 156버스 승차 남대구IC에서 하차";
    const forParking = "파라다이스컨벤션웨딩 주차장 이용 가능";
    const forBus = "564번, 156번 - 남대구 IC 하차";


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        // summer 올리브
        concept: "SUMMER",
        titleColor: "#405200",
        pointColor: "#405200",
        btnBgColor: "#405200",
        fontColor: "#fff",
        btnFontColor: "#fff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
}

    const msg1 = "내 꿈은 당신과 나태하게 사는 것\n더 이상 치열하지 않아도 괜찮은 것";
    const msg2 = "매일 손잡고 걸을 수 있는 여유로운 저녁이 있는 것\n지친 하루의 끝마다 서로 마주 앉아 이야길 들어줄 수 있는 것";
    const msg3 = "당신과 남은 생을 사는 것 \n\n <내 꿈은 당신과 나태하게 사는 것 中>";
    const msg4 = "\n다가오는 사월의 어느 멋진 날, 귀한 걸음 하시어\n저희 둘의 아름다운 순간을 함께해 주시고 축복해 주시면\n더없는 기쁨으로 간직하겠습니다.";


    const groomAccountList = [
        {
            role: "신랑",
            name: "문병관",
            bank: "신한은행",
            accountNumber : "110-410-387700",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8BCiqen"
        },
        {
            role: "신랑 부",
            name: "문사권",
            bank: "농협은행",
            accountNumber : "702070-56-008376",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "황혜영",
            bank: "대구은행",
            accountNumber : "141-08-025487-9",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FPcX1NW7k"
        }
    ]
    const brideAccountList = [
        {
            role: "신부",
            name: "이하린",
            bank: "국민은행",
            accountNumber : "629702-04-152843",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FaMx5gbYZ"
        }
        // ,{
        //     role: "신부 부",
        //     name: "이홍강",
        //     bank: "농협은행",
        //     accountNumber : "211042-56-058778",
        //     isKakao : false
        // }
        ,{
            role: "신부 모",
            name: "박윤옥",
            bank: "카카오뱅크",
            accountNumber : "3333-27-1273326",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "엄청 떨렸지",
            brideAnswer: "귀여웠었어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무 설렌다",
            brideAnswer: "두근두근해"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "나도 사랑해",
            brideAnswer: "평생행복해"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "아껴줄게요",
            brideAnswer: "난 항상 네편"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "많이많이♥️"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "문병관",
            call: "01056503499"
        }
        ,
        {
            role: "신랑 부",
            name: "문사권",
            call: "01066360179"
        },
        {
            role: "신랑 모",
            name: "황혜영",
            call: "01065360179"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이하린",
            call: "01021867191"
        }
        ,{
            role: "신부 부",
            name: "이홍강",
            call: "01064699689"
        }
        ,{
            role: "신부 모",
            name: "박윤옥",
            call: "01057734553"
        }
    ]


    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
    
        // 7FAD2A 그린
        // FA7384 핑크
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer weddingData={weddingData} color={"#ffffff"} groomNameEn={getRemoveSpaceName(weddingData.groomNameEn)} brideNameEn={getRemoveSpaceName(weddingData.brideNameEn)} letteringFontColor={"#ffffff"} dateColor={"#ecf5fc"} bottom={"28%"} bottom2={"20%"} dateBottom={"5%"} top={"1%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"}  fontSize={"13px"}/>
                    <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={"Always be with you"} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring brideName={getFirstKoName(weddingData.groomName)} groomName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                    <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                        <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                            <MotionWrapper initialY={70}>
                                <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                                    conceptStyle={conceptStyle} 
                                    btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                                    />
                                <MotionWrapper initialY={50}>
                                    {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                                    <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                    <Location_Desc forCar={forCar} forBus={forBus} forParking={forParking} forSubway={forSubway} conceptStyle={conceptStyle}/>
                                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                    <Footer />
                                </MotionWrapper>
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </>
            )}
        </div>
    );
    
};

export default LeeHaRin;